var React = require("react");
const PropTypes = require('prop-types');

var StatusBox = function(props) {
	return (
		<div className={"status-box " + props.type}>
			{props.children}
		</div>
	);
};

StatusBox.propTypes = {
	type: PropTypes.string,
};

StatusBox.defaultProps = {
	type: "default"
};

module.exports = StatusBox;
